module.exports = __webpack_public_path__ + "c5f1e0b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/icons/home-002.jpg
// module id = 1308
// module chunks = 8